/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedIconBubbleFacebook_item$ref: FragmentReference;
export type PdpSharedIconBubbleFacebook_item = {|
  +title: ?string,
  +$refType: PdpSharedIconBubbleFacebook_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedIconBubbleFacebook_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1ee214ae8acee7f3ada289e7d82a9d20';
module.exports = node;
